import FoxyShadowButton from './FoxyShadowButton';
import AnalyticsUtility from '../analytics/AnalyticsUtility';

export default class StartLoginButton extends FoxyShadowButton {
  componentDidMount() {
    AnalyticsUtility.logScreenLoadTime();
  }
}
